import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart } from 'lucide-react';

import { useDispatch, useSelector } from 'react-redux';
import {
  selectFavsRealties,
  selectShowMap,
  selectTotalCount,
} from '../../../redux/features/dashboard/dashboardSelectors';
import {
  setFavsRealties,
  setShowMap,
} from '../../../redux/features/dashboard/dashboardSlice';
import { useOpenPdf } from '../../../hooks/useOpenPdf';

import { ButtonTemplate } from '../buttons/ButtonTemplate';
import { mapButtonText } from '../../../data/constants';
import { useIsMobile } from '../../../hooks/useMediaQuery';

export const SearchToolbar = ({ currentCount = 0, totalCount: totalCountOverride }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const totalCountRedux = useSelector(selectTotalCount);
  const totalCount = totalCountOverride ?? totalCountRedux;
  const favsRealties = useSelector(selectFavsRealties);
  const showMap = useSelector(selectShowMap);
  const openPdf = useOpenPdf();

  const [favsCounter, setFavsCounter] = useState('0');
  const [mapText, setMapText] = useState(mapButtonText.show);
  const [withMyContact, setWithMyContact] = useState(false);

  const handleDownloadPDF = () => {
    if (favsRealties && favsRealties.length > 0) {
      openPdf({
        kind: 'archive',
        ids: favsRealties,
        details: withMyContact ? 'self' : 'none',
      });
    }
  };

  const handleDeleteFavs = () => {
    dispatch(setFavsRealties([]));
  };

  const handleMap = async () => {
    if (isMobile) {
      navigate('/map');
      return;
    }
    if (mapText === mapButtonText.show) {
      await dispatch(setShowMap(true));
    } else {
      await dispatch(setShowMap(false));
    }
  };

  useEffect(() => {
    setFavsCounter(`${favsRealties.length}`);
  }, [favsRealties?.length]);

  useEffect(() => {
    if (isMobile) {
      setMapText(mapButtonText.show);
      return;
    }
    if (showMap) {
      setMapText(mapButtonText.hide);
    } else {
      setMapText(mapButtonText.show);
    }
  }, [showMap, isMobile]);

  return (
    <div className="flex flex-wrap items-center gap-4 mb-4">
      <div>
        <span className="text-xs">
          {currentCount > 0 && totalCount > 0
            ? `${currentCount} of ${totalCount} results`
            : `${totalCount} results`}
        </span>
      </div>

      <ButtonTemplate
        text={mapText}
        handleClick={handleMap}
      />

      <ButtonTemplate
        counter={favsCounter}
        icon={Heart}
        isIconText={true}
        text={'Download PDFs'}
        handleClick={handleDownloadPDF}
      />

      <label className="flex items-center gap-1.5 text-xs text-blackColor cursor-pointer">
        <input
          type="checkbox"
          checked={withMyContact}
          onChange={e => setWithMyContact(e.target.checked)}
        />
        <span>My contact</span>
      </label>

      {favsCounter !== '0' ? (
        <ButtonTemplate
          text={'Delete all favs'}
          handleClick={handleDeleteFavs}
        />
      ) : null}
    </div>
  );
};
